import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { getConfigValue } from '@jutro/config';
export var fetchUserInfo = function fetchUserInfo(accessToken) {
  var userInfoEndPoint, userInfo;
  return _regeneratorRuntime.async(function fetchUserInfo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          userInfoEndPoint = "".concat(getConfigValue('JUTRO_AUTH_ISSUER', ''), "/v1/userinfo");
          _context.next = 3;
          return _regeneratorRuntime.awrap(fetch(userInfoEndPoint, {
            headers: {
              Authorization: "Bearer ".concat(accessToken)
            },
            method: 'GET'
          }));

        case 3:
          userInfo = _context.sent;
          return _context.abrupt("return", userInfo.json());

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
};